import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { DynamicRouteParameterWPrefix } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Shorts/Short'
import { mediaPlatformShortsRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Shorts'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Shorts/Short'

export const mediaPlatformShortRoute = createRoute({
  getParentRoute: () => mediaPlatformShortsRoute,
  path: DynamicRouteParameterWPrefix.SHORT_ID,
  loader: () => ({
    crumb: t('entity:publishing.short', { count: 1 }),
  }),
})

export const mediaPlatformShortLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformShortRoute,
  id: 'mediaPlatformShortLayout',
  component: Structure,
})

export const mediaPlatformShortRawRoute = createRoute({
  getParentRoute: () => mediaPlatformShortLayoutRoute,
  path: '/',
  component: Overview,
})
